import type { NearV1Market } from '../../../../packages/sdk/src/near';

export type MarketFilter = 'all' | 'curve' | 'graduated';
export type MarketSort = 'recent' | 'progress' | 'name';

// Only a terminal registry stage means graduated; a pool address alone is insufficient.
export function isGraduated(market: NearV1Market): boolean {
  return market.stage.toLowerCase() === 'graduated';
}

export function progressBps(market: Pick<NearV1Market, 'raisedYocto' | 'targetYocto'>): number | null {
  if (!/^\d+$/.test(market.raisedYocto) || !/^\d+$/.test(market.targetYocto)) return null;
  const target = BigInt(market.targetYocto);
  if (target === 0n) return null;
  const result = BigInt(market.raisedYocto) * 10000n / target;
  return Number(result > 10000n ? 10000n : result);
}

export function filterMarkets(rows: NearV1Market[], query: string, filter: MarketFilter, sort: MarketSort): NearV1Market[] {
  const search = query.trim().toLowerCase();
  return rows.filter(row => (!search || [row.name, row.symbol, row.receiptSymbol, row.launchId].some(value => value.toLowerCase().includes(search)))
    && (filter === 'all' || (filter === 'graduated' ? isGraduated(row) : row.stage.toLowerCase() === 'curve')))
    .sort((a, b) => sort === 'name' ? a.name.localeCompare(b.name) : sort === 'progress'
      ? (progressBps(b) ?? -1) - (progressBps(a) ?? -1) || b.observedAt - a.observedAt
      : b.observedAt - a.observedAt);
}

export const activityAction: Record<string, string> = {
  buy: 'Buy creator tokens', sell: 'Sell creator tokens', withdraw: 'Withdraw NEAR credit', create: 'Launch a token',
  buyer_acquire: 'Acquire receipts', fund_graduation: 'Graduate a market', claim_rewards: 'Collect earned rewards',
  request_redemption: 'Request redemption', commit_redemption: 'Confirm redemption', cancel_redemption: 'Cancel redemption',
  managed_exit: 'Return to NEAR', claim_refund: 'Recover unused funding', swap_creator_to_receipt: 'Swap tokens for receipts',
  swap_receipt_to_creator: 'Swap receipts for tokens', add_liquidity: 'Add liquidity', remove_liquidity: 'Remove liquidity',
};
export const activityState: Record<string, string> = {
  prepared: 'Ready for review', broadcast_unknown: 'Submission needs checking', finalized_transaction: 'Transaction confirmed',
  transaction_failed: 'Transaction failed', evidence_mismatch: 'Evidence needs review',
};
